import type { CommandResultsColumn } from "../../components/command-results-modal.component";
import { CommandResultsModal } from "../../components/command-results-modal.component";
import type { CommandResultRow } from "../../components/types";

type TimerProfileCommandResultsModalProps = {
  showModal: boolean;
  handleClose: () => void;
  isLoading: boolean;
  lastSyncDisplay: string;
  profiles: CommandResultRow[] | null;
  onBackup: () => void;
  onRestore: () => void;
  isRestoreMode?: boolean;
  errorMessage?: string | null;
};

export function TimerProfileCommandResultsModal({
  showModal,
  handleClose,
  isLoading,
  lastSyncDisplay,
  profiles,
  onBackup,
  onRestore,
  isRestoreMode = false,
  errorMessage,
}: TimerProfileCommandResultsModalProps) {
  const columns: CommandResultsColumn<CommandResultRow>[] = [
    {
      key: "zoneId",
      title: "Zone",
      render: (row) => row.zoneId ?? "--",
    },
    { key: "schedule", title: "Schedule" },
    {
      key: "dimLevel",
      title: "Dim Level",
      render: (row) => (row.dimLevel != null ? `${row.dimLevel}%` : "--"),
    },
    {
      key: "brightLevel",
      title: "Bright Level",
      render: (row) => (row.brightLevel != null ? `${row.brightLevel}%` : "--"),
    },
    { key: "action", title: "Action" },
    // {
    //   key: "actionId",
    //   title: "Action ID",
    //   render: (row) => row.actionId ?? "--",
    // },
    {
      key: "dayOfWeek",
      title: "Day of Week",
      render: (row) => row.dayOfWeek ?? "--",
    },
    // {
    //   key: "status",
    //   title: "Status",
    //   render: (row) => (
    //     <span
    //       className={`profile-status ${
    //         row.status === "ACTIVE" ? "" : "profile-status--disabled"
    //       }`}
    //     >
    //       {row.status}
    //     </span>
    //   ),
    // },
  ];

  return (
    <CommandResultsModal
      showModal={showModal}
      handleClose={handleClose}
      isLoading={isLoading}
      lastSyncDisplay={lastSyncDisplay}
      data={profiles}
      columns={columns}
      getRowKey={(row) => row.zoneId ?? 0}
      onConfirm={isRestoreMode ? onRestore : onBackup}
      isRestoreMode={isRestoreMode}
      confirmLabel="Backup"
      restoreLabel="Restore"
      errorMessage={errorMessage}
      emptyMessage="No profile data available."
      successMessage="The requested configuration parameters have been successfully retrieved from the node."
      restoreMessage="Restoring the configuration will revert all current values to the baseline"
    />
  );
}
